<div class="m-portlet m-portlet--mobile">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                    <!-- View All Appeals to Accreditation Committee -->
                </h3>
                <span class="form_head_title right">
          <button class="btn btn-with-border" (click)="goBack()">Back</button>
        </span>
                <!--
          <span class="form_head_title right">
            <button class="btn btn-with-border" (click)="viewGrievances()">View Grievances</button>
          </span>
          <span class="form_head_title right">
            <button class="btn btn-with-border" (click)="exportToExcel()">Export to Excel</button>
          </span> -->
            </div>
        </div>
    </div>
    <!-- <div class="modal-body">
    <div class="m_datatable m-datatable m-datatable--default m-datatable--loaded" id="local_data">
      <table class="m-datatable__table" style="display: block; min-height: 300px; overflow-x: auto;">
        <thead class="m-datatable__head">
          <tr class="m-datatable__row" style="left: 0px;">
            <th data-field="OrderID" class="m-datatable__cell m-datatable__cell--sort">
              <span style="width: 50px;;">S.NO</span>
            </th>
            <th data-field="ShipName" class="m-datatable__cell m-datatable__cell--sort">
              <span style="width: 800px;">Message Centre System</span>
            </th>
            <th data-field="Currency" class="m-datatable__cell m-datatable__cell--sort">
              <span style="width: 100px;">Date</span>
            </th>
          </tr>
        </thead>
        <tbody class="m-datatable__body">
          <tr data-row="0" class="m-datatable__row" style="left: 0px;" *ngFor="let requestDetails of emailMessages; let i=index">
            <td data-field="RecordID" class="m-datatable__cell">
              <span style="width: 50px;"> {{ i + 1}}
              </span>
            </td>
            <td data-field="OrderID" class="m-datatable__cell">
              <span style="width: 800px" [innerHTML]="requestDetails.mailBody"></span>
            </td>

            <td data-field="ShipName" class="m-datatable__cell">
              <span style="width: 100px;">{{requestDetails.createdOn | date: 'dd/MMM/yyyy'}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> -->
    <div class="m-content">
        <div class="row">
            <div class="col-lg-6">
                <!--begin::Portlet-->
                <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
                    <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded" id="scrolling_horizontal" style="position: static; zoom: 1;">
                        <table class="table table-striped">
                            <tr>
                                <th>
                                    <strong>Sr. No.</strong>
                                </th>
                                <th>
                                    <strong>Stage</strong>
                                </th>
                                <!-- <th>
                     <strong>Status</strong>
                   </th> -->
                <th>
                  <strong>Date</strong>
                </th>

              </tr>
              <tr *ngFor="let targetIdentifier of stages, let i = index;">
                  <!-- <td>{{i+1}}</td> -->

                <td>{{stages.length - i}}</td>
                <!-- <td>
                  <span style="width: 800px" [innerHTML]="targetIdentifier.stage"></span>
                </td> -->
                <!-- <td>
                      <span style="width: 800px" [innerHTML]="targetIdentifier.status"></span>
                  </td> -->
                  <td>
                    <span style="width: 800px">{{targetIdentifier.stage}}</span>
                  </td>
                <td>
                  {{targetIdentifier.stageDate | date : 'dd-MM-yyyy'}}
                </td>
               

              </tr>
              <tr *ngIf="stages.length === 0" style="color:grey;font-size:17px">
                <td colspan="8">
                  <p style="text-align:center;">No Message</p>
                </td>
              </tr>
              <!-- <tr *ngIf="batchArray.length === 0"   style="color:grey;font-size:17px">
                       <td colspan="8">
                         <p style="text-align:center;">No Batch Found For Respective Placement Officer</p>
                       </td>
                     </tr> -->
                        </table>
                    </div>
                </div>
                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->
            </div>
            <!-- second -->
            <div class="col-lg-6">
                <!--begin::Portlet-->
                <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
                    <div class="m_datatable m-datatable m-datatable--default m-datatable--error m-datatable--scroll m-datatable--loaded" id="scrolling_horizontal" style="position: static; zoom: 1;">
                        <table class="table table-striped">
                            <tr>
                                <th>
                                    <strong>Sr. No.</strong>
                                </th>
                                <th>
                                    <strong>Message Centre System</strong>
                                </th>
                                <!-- <th>
                          <strong>Date</strong>
                        </th> -->


              </tr>
              <tr *ngFor="let requestDetails of emailMessages; let i=index">
                <td>{{emailMessages.length - i}}</td>
                <td>
                  <span>({{requestDetails.msgDate | date: 'dd-MM-yyyy'}})</span>
                  <span [innerHTML]="requestDetails.msg"></span>
                </td>
                <!-- <td> 
                          
                          </td> -->

                            </tr>
                            <tr *ngIf="emailMessages.length === 0" style="color:grey;font-size:17px">
                                <td colspan="8">
                                    <p style="text-align:center;">No Message</p>
                                </td>
                            </tr>
                            <!-- <tr *ngIf="batchArray.length === 0"   style="color:grey;font-size:17px">
                         <td colspan="8">
                           <p style="text-align:center;">No Batch Found For Respective Placement Officer</p>
                         </td>
                       </tr> -->
                        </table>
                    </div>
                </div>
                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->

                <!--begin::Portlet-->

                <!--end::Portlet-->
            </div>

        </div>
    </div>
</div>